import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { RenderIcon } from "src/assets/icons";

import accountApi from "../account/AccountApi";
import { Separator } from "@radix-ui/react-separator";
import { useDateRange } from "src/context/DateRangeContext";
import { H2 } from "src/util/Typography";
import { useUser } from "src/context/UserContext";
import { CustomerServiceOutlined} from '@ant-design/icons'; 
import { Tooltip } from "antd";
interface NavbarProps {
  children: React.ReactNode;
}

const Navbar: React.FC<NavbarProps> = ({ children }) => {
  const history = useHistory();
  const { setDateRange,setIsFilterOpen } = useDateRange();
  const { setUser } = useUser()

  const [isSidebarOpen, setSidebarOpen] = useState<boolean>(false);

  const visible = [
    // {
    //   href: "/dashboard",
    //   name: "Dashboard",
    //   icon: "dashboardIcon",
    // },
    // {
    //   href: "/report",
    //   name: "Report",
    //   icon: "reporticon",
    // },
  ];
  const handleLogout = () => {
    accountApi.logout().then((success) => {
      if (success) {
        setDateRange(undefined)
        setUser({})
        history.push("/");

      }
    });
  };
  return (
    <div className="min-h-screen w-[100%] pt-[56px]">
      <div
        className="fixed top-0 z-[60] w-full bg-black global-header"
      >
        <div className="px-[14px] sm:px-[16px] py-[14px] sm:py-[16px] flex justify-between items-center py-1.5 min-h-[46px] relative">
          <div className="flex items-center">
            <a href="/dashboard">
              <RenderIcon type="alkimiLogo" className="w-[78px] h-[18px] sm:h-[24px] sm:w-[112px]"/>
            </a>
            {/* <ul className="hidden sm:flex space-x-4 mt-[5px]">
              <Separator
                color="white"
                orientation="vertical"
                className="w-[1px] ml-4 color-white bg-[#474747]"
              />

              {visible.map((item) => {
                const isActive = location.pathname === item.href;
                return (
                  <li key={item.href}>
                    <Link
                      to={item.href}
                      className={`flex items-center text-[#A1A1A1] text-[14px] leading-[19.88px] hover:text-[#F3F3F3]  ${
                        isActive ? "font-normal text-[#F3F3F3]" : "text-[#A1A1A1]"
                      } active:text-[#fff] focus:text-[#fff] focus-visible:text-[#fff] focus-within:text-[#fff]`}
                    >
                      <span className="ml-2 font-popins">{item.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul> */}
          </div>
          <div className="flex flex-end">
         <a href="https://alkimi.atlassian.net/servicedesk/customer/portal/141/group/-1"
  target="_blank"
  rel="noopener noreferrer"
  className="group hidden sm:flex items-center cursor-pointer mr-4 text-white/70 hover:text-white active:text-white/70 focus:text-white/70 visited:text-white/70"
>
  <CustomerServiceOutlined className="text-inherit mb-[1px]" />
  <span className="ml-2 text-[13px] leading-[18.2px] font-popins">
    Support
  </span>
</a>
          <div
            className="hidden sm:flex items-center cursor-pointer opacity-70 hover:opacity-100"
            onClick={handleLogout}
          >
            <RenderIcon type="logoutIcon" width={25} height={25} />
            <div className="ml-2 text-[13px] leading-[18.2px] text-[#FFFFFF] font-popins">Log Out</div>
          </div>
          </div>
         
           {/* <div className="flex space-x-2  sm:w-auto"> */}
          <div className="flex gap-3 items-center sm:hidden">
          <div
            className="sm:hidden align-center cursor-pointer font-popins flex gap-2 items-center bg-[#111111] px-4 py-2 rounded-full"
            onClick={() => setIsFilterOpen(prev=>!prev)}
            >
            <RenderIcon type="filterDownIcon" /> Filter
          </div>
          <div
            className="sm:hidden align-center cursor-pointer"
            onClick={() => setSidebarOpen(true)}
          >
            <RenderIcon type="barIcon" />     
          </div>
          </div>
            {/* </div> */}
          {isSidebarOpen && (
            <div className="fixed top-0 left-0 flex flex-col  h-full w-full  bg-[black] p-4 z-[9999]">
              <div className="flex justify-end">
                <div onClick={() => setSidebarOpen(false)}>
                  <RenderIcon type="xcloseIcon" width={24} height={24} />
                </div>
              </div>
              <nav className="mt-4">
                {/* {visible.map((item) => {
                  const isActive = location.pathname === item.href;

                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`flex items-center p-4 text-[13px] leading-[18.2px]  rounded bg-[#131313] mb-4 font-popins ${
                        isActive ? "text-[#fff]" : `text-[#A1A1A1]`
                      } `}
                      onClick={() => setSidebarOpen(false)}
                    >
                      <RenderIcon
                        type={item?.icon}
                        className={`mr-2`}
                        color={isActive ? "#5F43FF" : ""}
                      />
                      {item.name}
                    </Link>
                  );
                })} */}
                <H2 className="uppercase mb-4 flex justify-center">Menu</H2>
                <a
                  href="https://alkimi.atlassian.net/servicedesk/customer/portal/141/group/-1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex w-[100%] items-center justify-center p-4 text-[13px] leading-[18.2px] rounded bg-[#131313] mb-4 font-popins text-[#A1A1A1] no-underline hover:text-white"
                >
                  <CustomerServiceOutlined className="mr-2 group-hover:text-white" style={{ fontSize: '20px' }} />
                  Support
                </a>
                <button
                  className="flex w-[100%] items-center justify-center p-4 text-[13px] leading-[18.2px] border-none rounded bg-[#131313] mb-4 font-popins text-[#A1A1A1]"
                  onClick={() => handleLogout()}
                >
                  <RenderIcon
                    type={'logoutIcon'}
                    className="mr-2"
                    width={20}
                    height={20}
                  />
                  Log Out
                </button>
              </nav>
            </div>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default Navbar;
